import React, { CSSProperties, FC } from 'react'

import cn from './styles.module.scss'

import { SvgInfo } from './icons'

export interface IInformativeProps {
  style?: CSSProperties
  className?: string
  children: React.ReactNode
}

const Informative: FC<IInformativeProps> = ({ style, children }) => {
  return (
    <>
      <div className={cn.informative} style={style}>
        <div className={cn.icon}>
          <SvgInfo />
        </div>
        <div className={cn.children}>{children}</div>
      </div>
    </>
  )
}

export default Informative
